import { Calendar, Hash, LucideProps, Mail, Phone, User, FileDigit, MapPin } from 'lucide-react';

export const CodelistIcons = {
	ssn: Hash,
	firstName: User,
	lastName: User,
	dateOfBirth: Calendar,
	mobilePhone: Phone,
	email: Mail,
	address: MapPin,
	postalCode: MapPin,
	postalPlace: MapPin,
	country: MapPin,
	customId: FileDigit
};

export type CodelistIcon = React.ForwardRefExoticComponent<
	Omit<LucideProps, 'ref'> & React.RefAttributes<SVGSVGElement>
>;
